import type { WritableDraft } from 'immer';
import type { SwapState } from './types';

export const updateAvailableItemsForCurrencies = (state: WritableDraft<SwapState>) => {
  const availableCurrencies = getAvailableItemsForCurrencies(
    state.referenceData.currencies.currenciesList,
    state.referenceData.securities.securitiesList
  );
  state.form.fromCurrency = state.form.fromCurrency.updateAvailableItems(availableCurrencies);
  state.form.toCurrency = state.form.toCurrency.updateAvailableItems(availableCurrencies);
};

export const getAvailableItemsForCurrencies = (
  currenciesList: SwapState['referenceData']['currencies']['currenciesList'],
  securitiesList: SwapState['referenceData']['securities']['securitiesList']
) => {
  const currenciesSet = new Set(securitiesList.flatMap(security => [security.BaseCurrency, security.QuoteCurrency]));
  const availableCurrencies = currenciesList.filter(currency => currenciesSet.has(currency.Symbol));
  return availableCurrencies;
};
